exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".co-product__rating{display:flex;cursor:pointer;line-height:16px}.co-product__rating--product-slider{margin:auto}.co-product__rating:hover{text-decoration:none}@media (min-width:480px){.co-product__rating{justify-content:center}}.co-product__review-count{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:400;margin-left:2px;color:#3d3d3d}.co-product__review-count--large{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:400}@media (min-width:480px){.co-product__rating{margin:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./shared/interim/product/rating/_style.scss
// module id = 780
// module chunks = 0